import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BusSolid = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M13.28 1.77782C13.28 1.196 12.8266 1.10442 12.56 1.13135H3.43997C3.19997 1.13136 2.71997 1.26065 2.71997 1.77782V3.88001H13.28V1.77782ZM2.71997 7.08001V5.08001H7.39997V7.08001H2.71997ZM8.59997 7.08001H13.28V5.08001H8.59997V7.08001ZM2.71997 8.28001H13.28V12.6061C13.28 12.994 12.96 13.0909 12.8 13.0909H3.19997C2.81597 13.0909 2.71997 12.7677 2.71997 12.6061V8.28001ZM6.71997 10.3642C6.71997 11.0336 6.18271 11.5763 5.51997 11.5763C4.85723 11.5763 4.31997 11.0336 4.31997 10.3642C4.31997 9.69473 4.85723 9.15204 5.51997 9.15204C6.18271 9.15204 6.71997 9.69473 6.71997 10.3642ZM11.68 10.3642C11.68 11.0336 11.1427 11.5763 10.48 11.5763C9.81723 11.5763 9.27997 11.0336 9.27997 10.3642C9.27997 9.69473 9.81723 9.15204 10.48 9.15204C11.1427 9.15204 11.68 9.69473 11.68 10.3642ZM6.87997 2.02626C6.5486 2.02626 6.27997 2.29489 6.27997 2.62626C6.27997 2.95763 6.5486 3.22626 6.87997 3.22626H9.11997C9.45134 3.22626 9.71997 2.95763 9.71997 2.62626C9.71997 2.29489 9.45134 2.02626 9.11997 2.02626H6.87997Z" />;
    t2 = <path d="M10.3999 13.0103V14.6264C10.3999 14.8204 10.5866 14.8688 10.6399 14.8688H12.0799C12.1599 14.8688 12.3199 14.8204 12.3199 14.6264V13.0103" />;
    t3 = <path d="M3.67993 13.0103V14.6264C3.67993 14.8204 3.8666 14.8688 3.91993 14.8688H5.35993C5.43993 14.8688 5.59993 14.8204 5.59993 14.6264V13.0103" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 16">{t1}{t2}{t3}</IconWrapper>;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { BusSolid };